import { GET_ALL_RAN_DB_SITES } from '../../../common/constants/constants';
import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const getAllRanSites = async (ranFilters = {}) => {
  try {
    // Extract pagination and sorting parameters
    const { page = 1, limit = 50, sortBy, sortOrder, ...otherFilters } = ranFilters;

    const response = await apiClient.get(GET_ALL_RAN_DB_SITES, {
      params: {
        page,
        limit,
        ...(sortBy && { sortBy }),
        ...(sortOrder && { sortOrder }),
        ...otherFilters,
      },
    });

    // Filter the response to only include the 27 specific fields for RAN DB
    const allowedFields = [
      'site_code',
      'physical',
      'locked_status',
      'vendor',
      'region',
      'coverage_type',
      'lat',
      'long',
      'site_status',
      'pta_tehsil',
      'pta_district',
      'pta_province',
      'prefix',
      'city_prefix_based',
      'technical_city',
      'commercial_district',
      'commercial_city',
      'mbu',
      'franchise_id',
      'site_type',
      'sharing_type_hostguest',
      'omo_name',
      'b2s_id',
      'bsc',
      'bsc_code',
      'lte_technology',
      'deodar_tag',
      'archived_type',
      'status',
      'uploaded_at',
      'id',
    ];

    // Filter the data to only include allowed fields
    if (response?.data?.response?.data && Array.isArray(response.data.response.data)) {
      const filteredData = response.data.response.data.map((item) => {
        const filteredItem = {};
        allowedFields.forEach((field) => {
          if (item.hasOwnProperty(field)) {
            filteredItem[field] = item[field];
          }
        });
        return filteredItem;
      });

      return {
        ...response.data.response,
        data: filteredData,
      };
    }

    return response?.data?.response || response?.data;
  } catch (error) {
    handleApiError(error);
  }
};
